var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"pt-28 min-h-screen flex flex-col"},[_c('BooksView',{staticClass:"flex-grow"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }